var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"review"},[_c('div',{staticClass:"review__questions-wrapper"},[_c('h3',{staticClass:"review__title"},[_vm._v("Questions You Missed:")]),_vm._l((_vm.missedQuestions),function(question,i){return _c('ReviewQuestion',{key:`review-question-${i}`,staticClass:"review__question",attrs:{"question":question}})})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }